import { apiClient } from '../services/api';
import { PAGE_BY_EVENT, type UserEventName } from '../types/user-events';

/**
 * Fire-and-forget UI event tracking for monitoring. Never throws to callers.
 */
export function trackUserEvent(
  event: UserEventName,
  metadata?: Record<string, string>,
): void {
  void apiClient.postUserEvent({
    event,
    page: PAGE_BY_EVENT[event],
    metadata,
  }).catch(() => {
    // Analytics must never break the app
  });
}
